// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-category-view-js": () => import("./../../../src/templates/CategoryView.js" /* webpackChunkName: "component---src-templates-category-view-js" */),
  "component---src-templates-item-view-js": () => import("./../../../src/templates/ItemView.js" /* webpackChunkName: "component---src-templates-item-view-js" */)
}

